"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpringboardEngagementMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SpringboardContext_1 = require("./SpringboardContext");
var UserAvatar_1 = require("./UserAvatar");
var styles = __importStar(require("./EngagementMenu.css"));
var MenuItemButton_1 = require("../MenuItemButton/MenuItemButton");
var AuthenticationContext_1 = require("./AuthenticationContext");
var StoredState_1 = require("../StoredState/StoredState");
var zod_1 = require("zod");
var TelemetryContext_1 = require("../Telemetry/TelemetryContext");
var clsx_1 = __importDefault(require("clsx"));
var NavigationTheming_css_1 = require("../Navigation/NavigationTheming.css");
var RequireAccountPrompt_1 = require("./RequireAccountPrompt");
var pages_common_1 = require("@qwilr/pages-common");
var SpringboardEngagementViewStoreContext_1 = require("./SpringboardEngagementViewStoreContext");
var aboutQwilrUrl = "https://qwilr.com?utm_source=public_page&utm_medium=product_menu&utm_campaign=about_qwilr";
var DEFAULT_PERSIST_TIME = 5000;
var PopoverMenuItem = function (_a) {
    var label = _a.label, icon = _a.icon, demoModeMessage = _a.demoModeMessage, buttonProps = __rest(_a, ["label", "icon", "demoModeMessage"]);
    var demoMode = (0, SpringboardEngagementViewStoreContext_1.useSpringboardEngagementViewStoreContext)().demoMode;
    if (demoMode && demoModeMessage) {
        return (React.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: demoModeMessage, size: kaleidoscope_1.TooltipSize.Large },
            React.createElement(MenuItemButton_1.MenuItemButton, __assign({ label: label, labelSize: "s", icon: icon, disabled: true }, buttonProps))));
    }
    return React.createElement(MenuItemButton_1.MenuItemButton, __assign({ label: label, labelSize: "s", icon: icon }, buttonProps));
};
var LoggedInMenu = function () {
    var signOut = (0, AuthenticationContext_1.useAuthenticationContext)().signOut;
    var _a = (0, SpringboardContext_1.useSpringboardContext)(), getSpringboardUrl = _a.getSpringboardUrl, getAuthenticationUrl = _a.getAuthenticationUrl, pageOwnerEmail = _a.pageOwnerEmail;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    return (React.createElement(React.Fragment, null,
        pageOwnerEmail && (React.createElement(PopoverMenuItem, { label: "Contact page owner", href: function () { return "mailto:".concat(pageOwnerEmail); }, onClick: function () { return track("Clicked Contact Page Owner", { event_origin: "springboard engagement menu" }); }, icon: React.createElement(icons_1.Mail, null) })),
        React.createElement(PopoverMenuItem, { label: "Saved pages", href: function () { return getSpringboardUrl("saved", SpringboardContext_1.SpringboardAppOrigin.SpringboardEngagementMenu); }, icon: React.createElement(icons_1.Bookmark, null) }),
        React.createElement(PopoverMenuItem, { label: "Profile", href: function () { return getAuthenticationUrl("user/profile", SpringboardContext_1.AuthenticationOrigin.SpringboardEngagementMenu); }, icon: React.createElement(icons_1.User, null) }),
        React.createElement(PopoverMenuItem, { label: "About Qwilr", href: function () { return aboutQwilrUrl; }, onClick: function () { return track("Clicked About Qwilr", { is_auth: true }); }, icon: React.createElement(icons_1.InformationCircle, null) }),
        React.createElement(PopoverMenuItem, { label: "Log out", onClick: function () { return signOut(); }, icon: React.createElement(icons_1.Logout, null) })));
};
var LoggedOutMenu = function (_a) {
    var onClickContactPageOwner = _a.onClickContactPageOwner;
    var _b = (0, SpringboardContext_1.useSpringboardContext)(), getAuthenticationUrl = _b.getAuthenticationUrl, pageUrl = _b.pageUrl, pageOwnerEmail = _b.pageOwnerEmail;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var loginUrl = getAuthenticationUrl("login", SpringboardContext_1.AuthenticationOrigin.SpringboardEngagementMenu, pageUrl);
    var signupUrl = getAuthenticationUrl("signup", SpringboardContext_1.AuthenticationOrigin.SpringboardEngagementMenu, pageUrl);
    var contactOwnerEnabled = !!pageOwnerEmail;
    return (React.createElement(React.Fragment, null,
        contactOwnerEnabled && (React.createElement(PopoverMenuItem, { label: "Contact page owner", onClick: onClickContactPageOwner, icon: React.createElement(icons_1.Mail, null), demoModeMessage: "Clients can contact you via email from a live Qwilr page" })),
        React.createElement(PopoverMenuItem, { label: "Sign up", openInSameTab: true, href: function () { return signupUrl; }, onClick: function () { return track("Clicked Springboard Menu Consumer Signup"); }, icon: React.createElement(icons_1.User, null), demoModeMessage: "Signing up to Springboard allows your clients to stay engaged with your Qwilr pages" }),
        React.createElement(PopoverMenuItem, { label: "Log in", openInSameTab: true, href: function () { return loginUrl; }, onClick: function () { return track("Clicked Springboard Menu Consumer Login"); }, icon: React.createElement(icons_1.Login, null), demoModeMessage: "Logging into Springboard allows your clients to stay engaged with your Qwilr pages" }),
        React.createElement(PopoverMenuItem, { label: "About Qwilr", href: function () { return aboutQwilrUrl; }, onClick: function () { return track("Clicked About Qwilr", { is_auth: false }); }, icon: React.createElement(icons_1.InformationCircle, null) })));
};
var WithLoadingState = function (_a) {
    var loading = _a.loading, children = _a.children;
    if (loading) {
        return (React.createElement("div", { className: styles.ghostIconButton },
            React.createElement(kaleidoscope_1.GhostBlock, { className: styles.ghostBlock })));
    }
    return React.createElement(React.Fragment, null, children);
};
var SaveButtonWithPopover = function (_a) {
    var saved = _a.saved, deferredSavePage = _a.deferredSavePage, pending = _a.pending, handleSave = _a.handleSave, handleShowUnsavePrompt = _a.handleShowUnsavePrompt, handleDelete = _a.handleDelete;
    var isSignedIn = (0, AuthenticationContext_1.useAuthenticationContext)().isSignedIn;
    var isInline = (0, SpringboardEngagementViewStoreContext_1.useSpringboardEngagementViewStoreContext)().isInline;
    if (!isSignedIn) {
        return (React.createElement(kaleidoscope_1.Popover, { padding: "none", className: styles.createAccountPopoverContainer, size: kaleidoscope_1.PopoverSize.Large, offset: isInline ? 16 : 8, button: function (buttonProps) {
                return React.createElement(SaveButton, { buttonProps: buttonProps, pending: false, saved: false });
            } },
            React.createElement(RequireAccountPrompt_1.RequireSpringboardAccountPrompt, { action: "save page", deferredAction: deferredSavePage })));
    }
    if (isSignedIn && saved) {
        return (React.createElement(kaleidoscope_1.Popover, { padding: "none", size: kaleidoscope_1.PopoverSize.Medium, offset: isInline ? 16 : 8, recalculatePositionOnResize: true, onChange: function (open) {
                if (open) {
                    handleShowUnsavePrompt();
                }
            }, button: function (props) {
                return React.createElement(SaveButton, { saved: saved, pending: pending, buttonProps: props });
            } },
            React.createElement(UnsavePrompt, { handleDelete: handleDelete })));
    }
    return React.createElement(SaveButton, { pending: pending, onSave: handleSave, saved: saved });
};
var SaveButton = function (_a) {
    var pending = _a.pending, saved = _a.saved, buttonProps = _a.buttonProps, onSave = _a.onSave;
    var _b = (0, SpringboardEngagementViewStoreContext_1.useSpringboardEngagementViewStoreContext)(), isInline = _b.isInline, demoMode = _b.demoMode;
    var onClickEffect = saved ? "Unsave page" : "Save page";
    var tooltipContent = demoMode ? "Your clients can save the page to get back to it easier" : onClickEffect;
    var isDisabled = pending || demoMode;
    var handleClick = function (event, buttonProps) {
        pages_common_1.PubSub.publish("qwilr:engagement-menu-clicked", { clicked: true });
        if (onSave) {
            onSave();
        }
        else {
            buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick(event);
        }
    };
    return (React.createElement(kaleidoscope_1.Tooltip, { wrapTarget: isDisabled, content: tooltipContent, size: demoMode ? kaleidoscope_1.TooltipSize.Large : kaleidoscope_1.TooltipSize.Small, show: !isInline && !demoMode ? false : undefined },
        React.createElement(kaleidoscope_1.Button, __assign({}, buttonProps, { buttonState: pending ? kaleidoscope_1.ButtonState.Waiting : kaleidoscope_1.ButtonState.Idle, disabled: isDisabled, className: styles.inlineSaveButton, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function (event) { return handleClick(event, buttonProps); }, isIconOnly: isInline }),
            React.createElement("div", { className: styles.inlineSaveButtonContents },
                saved ? React.createElement(icons_1.BookmarkFilled, null) : React.createElement(icons_1.Bookmark, null),
                !isInline && (React.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, saved ? "Saved" : "Save"))))));
};
var UnsavePrompt = function (_a) {
    var handleDelete = _a.handleDelete;
    var getSpringboardUrl = (0, SpringboardContext_1.useSpringboardContext)().getSpringboardUrl;
    return (React.createElement("div", { className: styles.unsavePopover },
        React.createElement("div", { className: styles.unsavePopoverIcon },
            React.createElement(icons_1.Tick, { size: icons_1.IconSize.Medium })),
        React.createElement(kaleidoscope_1.Text, { strong: true }, "Page saved to Qwilr Springboard"),
        React.createElement("div", { className: styles.unsavePopoverActions },
            React.createElement(kaleidoscope_1.Button, { onClick: handleDelete, type: kaleidoscope_1.ButtonType.Secondary, width: "full" }, "Unsave"),
            React.createElement(kaleidoscope_1.Button, { openInSameTab: true, href: function () { return getSpringboardUrl("saved", SpringboardContext_1.SpringboardAppOrigin.GoToSavedPages); }, width: "full" }, "Go to saved pages"))));
};
var NotificationMessage;
(function (NotificationMessage) {
    NotificationMessage["SaveSuccessful"] = "Page saved";
    NotificationMessage["UnsaveSuccessful"] = "Page removed from saved";
    NotificationMessage["ErrorOnSave"] = "There was a problem saving the page. Please try again.";
    NotificationMessage["ErrorOnUnsave"] = "There was a problem removing the page from saved. Please try again.";
})(NotificationMessage || (NotificationMessage = {}));
var PageSavedStatusNotification = function (_a) {
    var isShowing = _a.isShowing, onClose = _a.onClose, type = _a.type, message = _a.message, showAction = _a.showAction;
    var getSpringboardUrl = (0, SpringboardContext_1.useSpringboardContext)().getSpringboardUrl;
    return (React.createElement(kaleidoscope_1.Layer, { offset: 1 }, function () { return (React.createElement("div", { className: (0, clsx_1.default)(styles.notification, NavigationTheming_css_1.navigationThemeLightOverride) },
        React.createElement(kaleidoscope_1.Notification, { isShowing: isShowing, onClose: onClose, type: type },
            React.createElement("div", { className: styles.notificationBody },
                React.createElement(kaleidoscope_1.Text, { size: "s" }, message)),
            showAction && (React.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, href: function () { return getSpringboardUrl("saved", SpringboardContext_1.SpringboardAppOrigin.SavedPageNotification); } }, "Saved pages"))))); }));
};
var EngagementMenu = function () {
    var _a = (0, AuthenticationContext_1.useAuthenticationContext)(), authContextIsSignedIn = _a.isSignedIn, isInitialized = _a.isInitialized, authContextUser = _a.user;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var _b = (0, SpringboardContext_1.useSpringboardContext)(), savePageToSpringboard = _b.savePage, fetchPageStatus = _b.fetchPageStatus, deletePageFromSpringboard = _b.deletePage;
    var _c = (0, SpringboardEngagementViewStoreContext_1.useSpringboardEngagementViewStoreContext)(), isInline = _c.isInline, demoMode = _c.demoMode;
    var isSignedIn = demoMode ? false : authContextIsSignedIn;
    var user = demoMode ? undefined : authContextUser;
    var loadingUser = !isInitialized;
    var _d = __read((0, react_1.useState)(true), 2), loadingSavedState = _d[0], setLoadingSavedState = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), showVerifyIdentityPrompt = _e[0], setShowVerifyIdentityPrompt = _e[1];
    var _f = __read((0, react_1.useState)(""), 2), notificationMessage = _f[0], setNotificationMessage = _f[1];
    var _g = __read((0, react_1.useState)(""), 2), errorMessage = _g[0], setErrorMessage = _g[1];
    var popoverRef = (0, react_1.useRef)(null);
    var _h = __read((0, react_1.useState)(false), 2), saved = _h[0], setSaved = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), pending = _j[0], setPending = _j[1];
    var _k = __read((0, StoredState_1.useLocalStorage)({
        key: "shouldSavePage",
        schema: zod_1.z.boolean(),
        default: false,
    }), 2), hasDeferredSavePage = _k[0], setHasDeferredSavePage = _k[1];
    (0, react_1.useEffect)(function () {
        if (isInitialized) {
            if (isSignedIn) {
                fetchPageStatus().then(function (saved) {
                    setSaved(saved);
                });
            }
            setLoadingSavedState(false);
        }
    }, [isSignedIn, isInitialized]);
    (0, react_1.useEffect)(function () {
        if (isSignedIn && hasDeferredSavePage) {
            savePageToSpringboard().then(function () {
                track("Saved Qwilr Page");
                setSaved(true);
                setHasDeferredSavePage(false);
            });
        }
    }, [isSignedIn, hasDeferredSavePage]);
    var savePage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, savePageToSpringboard()];
                case 2:
                    _a.sent();
                    setSaved(true);
                    setPending(false);
                    track("Saved Qwilr Page");
                    setNotificationMessage(NotificationMessage.SaveSuccessful);
                    setTimeout(function () { return setNotificationMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    setPending(false);
                    setErrorMessage(NotificationMessage.ErrorOnSave);
                    setTimeout(function () { return setErrorMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var deletePage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, deletePageFromSpringboard()];
                case 2:
                    _a.sent();
                    setSaved(false);
                    setPending(false);
                    track("Unsaved Qwilr Page", { event_origin: "springboard engagement menu" });
                    setNotificationMessage(NotificationMessage.UnsaveSuccessful);
                    setTimeout(function () { return setNotificationMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 3:
                    error_2 = _a.sent();
                    setPending(false);
                    setErrorMessage(NotificationMessage.ErrorOnUnsave);
                    setTimeout(function () { return setErrorMessage(""); }, DEFAULT_PERSIST_TIME);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var deferSavePage = function () {
        setHasDeferredSavePage(true);
    };
    var onShowUnsavePrompt = function () {
        setNotificationMessage("");
        setErrorMessage("");
    };
    var handlePopoverEnter = function (node) {
        setTimeout(function () {
            if (!popoverRef.current)
                return;
            popoverRef.current.style.width = "".concat(node.offsetWidth, "px");
            popoverRef.current.style.height = "".concat(node.offsetHeight, "px");
            return popoverRef.current.offsetHeight;
        });
    };
    var handlePopoverEntered = function (node) {
        setTimeout(function () {
            if (!popoverRef.current)
                return;
            popoverRef.current.style.width = "auto";
            popoverRef.current.style.height = "auto";
        }, 100);
    };
    var handlePopoverExit = function (node) {
        if (!popoverRef.current)
            return;
        popoverRef.current.style.width = "".concat(node.offsetWidth, "px");
        popoverRef.current.style.height = "".concat(node.offsetHeight, "px");
        return popoverRef.current.offsetHeight;
    };
    var popoverSize = function () {
        if (showVerifyIdentityPrompt) {
            return "large";
        }
        if (isSignedIn) {
            return "medium";
        }
        return "small";
    };
    return (React.createElement("div", { className: styles.inlineContainer({ applyPadding: !isInline }) },
        React.createElement(WithLoadingState, { loading: loadingSavedState },
            React.createElement(SaveButtonWithPopover, { saved: saved, deferredSavePage: deferSavePage, pending: pending, handleSave: savePage, handleShowUnsavePrompt: onShowUnsavePrompt, handleDelete: deletePage })),
        React.createElement(PageSavedStatusNotification, { isShowing: !!notificationMessage, onClose: function () { return setNotificationMessage(""); }, type: kaleidoscope_1.NotificationType.Success, message: notificationMessage, showAction: notificationMessage === NotificationMessage.SaveSuccessful }),
        React.createElement(PageSavedStatusNotification, { isShowing: !!errorMessage, onClose: function () { return setErrorMessage(""); }, type: kaleidoscope_1.NotificationType.Error, message: errorMessage }),
        React.createElement(WithLoadingState, { loading: loadingUser },
            React.createElement(kaleidoscope_1.Popover, { offset: isInline ? 16 : 8, padding: "none", size: kaleidoscope_1.PopoverSize.Auto, recalculatePositionOnResize: true, button: function (buttonProps) {
                    var _a;
                    return (React.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { "aria-label": isSignedIn ? "Springboard options" : "Page options", isRound: isSignedIn, icon: isSignedIn && !!user ? (React.createElement(UserAvatar_1.UserAvatar, { size: "small", url: user.profileImageUrl, name: user.fullName ? user.fullName : (_a = user.emailAddress) !== null && _a !== void 0 ? _a : "" })) : (React.createElement(icons_1.OptionsVertical, null)) })));
                }, onChange: function (isOpen) {
                    pages_common_1.PubSub.publish("qwilr:engagement-menu-clicked", { clicked: true });
                    if (isOpen) {
                        setShowVerifyIdentityPrompt(false);
                    }
                } },
                React.createElement("div", { className: styles.popoverInner({ size: popoverSize() }), ref: popoverRef },
                    React.createElement(react_transition_group_1.TransitionGroup, { component: null }, showVerifyIdentityPrompt ? (React.createElement(react_transition_group_1.Transition, { key: "springboard-account-prompt", timeout: kaleidoscope_1.AnimationDuration.Medium, onExit: handlePopoverExit, onEnter: handlePopoverEnter, onEntered: handlePopoverEntered }, function (status) { return (React.createElement("div", { className: styles.popoverPanel({ size: "large", status: status }) },
                        React.createElement(kaleidoscope_1.IconButton, { className: styles.popoverPanelBack, icon: React.createElement(icons_1.ChevronLeft, null), onClick: function () { return setShowVerifyIdentityPrompt(false); } }),
                        React.createElement(RequireAccountPrompt_1.RequireSpringboardAccountPrompt, { action: "contact owner" }))); })) : (React.createElement(react_transition_group_1.Transition, { key: "menu", timeout: kaleidoscope_1.AnimationDuration.Medium, onExit: handlePopoverExit, onEnter: handlePopoverEnter, onEntered: handlePopoverEntered }, function (status) {
                        var _a;
                        return (React.createElement("div", { className: styles.popoverPanel({ status: status, size: popoverSize() }) },
                            isSignedIn && !!user && (React.createElement("div", { className: styles.user },
                                React.createElement(UserAvatar_1.UserAvatar, { size: "large", url: user.profileImageUrl, name: user.fullName ? user.fullName : (_a = user.emailAddress) !== null && _a !== void 0 ? _a : "" }),
                                React.createElement("div", { className: styles.userDetails },
                                    React.createElement(kaleidoscope_1.Text, { strong: true, size: "s", lineHeight: "compact" }, user.fullName),
                                    React.createElement(kaleidoscope_1.Text, { size: "s", lineHeight: "compact" }, user.emailAddress)))),
                            React.createElement("div", { className: styles.menu }, isSignedIn ? (React.createElement(LoggedInMenu, null)) : (React.createElement(LoggedOutMenu, { onClickContactPageOwner: function () {
                                    setShowVerifyIdentityPrompt(true);
                                } })))));
                    }))))))));
};
var MaybeSpringboardEngagementMenu = function (_a) {
    var children = _a.children;
    var showEngagementMenu = (0, SpringboardEngagementViewStoreContext_1.useSpringboardEngagementViewStoreContext)().showEngagementMenu;
    if (showEngagementMenu) {
        return React.createElement(React.Fragment, null, children);
    }
    return null;
};
var SpringboardEngagementMenu = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(MaybeSpringboardEngagementMenu, null,
            React.createElement(EngagementMenu, null))));
};
exports.SpringboardEngagementMenu = SpringboardEngagementMenu;
